import React, { useEffect, useState } from "react";
import axios from "axios";

const Dashboard = () => {
  const [stats, setStats] = useState(null);
  const [activities, setActivities] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const statsRes = await axios.get(
          "https://langbridge-backend.onrender.com/api/dashboard/summary",
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        setStats(statsRes.data);

        const activityRes = await axios.get(
          "https://langbridge-backend.onrender.com/api/dashboard/activity",
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        setActivities(activityRes.data);
      } catch (error) {
        console.error("Dashboard fetch error:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <section className="bg-gray min-h-screen">
      <div className="p-6 md:p-10">
        <h1 className="text-3xl font-bold text-blue mb-6">Welcome back,</h1>

        {/* Stats Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-10">
          <div className="bg-white shadow-md rounded-xl p-6 text-center">
            <h2 className="text-xl font-semibold text-blue">Flashcards</h2>
            <p className="text-3xl font-bold text-purple">
              {stats?.flashcardsCount || 0}
            </p>
          </div>
          <div className="bg-white shadow-md rounded-xl p-6 text-center">
            <h2 className="text-xl font-semibold text-blue ">
              Quizzes Taken
            </h2>
            <p className="text-3xl font-bold text-purple">
              {stats?.quizzesTaken || 0}
            </p>
          </div>
          <div className="bg-white shadow-md rounded-xl p-6 text-center">
            <h2 className="text-xl font-semibold text-blue">Accuracy</h2>
            <p className="text-3xl font-bold text-purple">
              {stats?.avgScore || 0}%
            </p>
          </div>
        </div>

        {/* Recent Activity */}
        <div>
          <h2 className="text-2xl font-semibold text-charcoal mb-4">
            Recent Activity
          </h2>
          <ul className="space-y-3">
            {activities.length === 0 ? (
              <p className="text-green">No recent activity yet.</p>
            ) : (
              activities.map((item, index) => (
                <li
                  key={index}
                  className="bg-gray border border-purple rounded-lg p-4 shadow-sm"
                >
                  <p className="text-blue">{item.message}</p>
                  <span className="text-sm text-charcoal">
                    {new Date(item.createdAt).toLocaleString()}
                  </span>
                </li>
              ))
            )}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Dashboard;
